export default __webpack_public_path__ + "static/media/login-bg.686847a2.png";